import { inject } from '@angular/core';
import { HttpLink, HttpLinkHandler } from 'apollo-angular/http';
// Need to ignore the import, because there are no module types, and the ones from @types/extract-files are for v11 yet.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import extractFiles from 'extract-files/extractFiles.mjs';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import isExtractableFile from 'extract-files/isExtractableFile.mjs';
import { environment } from '../../../environments/environment';

/**
 * @description HTTP.
 * @exports
 * @returns {HttpLinkHandler}
 */
export function http(): HttpLinkHandler {
  const httpLink = inject(HttpLink);

  return httpLink.create({
    uri: environment.GRAPHQL_URI,
    /**
     * Extract files.
     *
     * @param {unknown} body Body.
     * @returns {unknown}
     */
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    extractFiles: (body) => extractFiles(body, isExtractableFile)
  });
}
